import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import EditReturnLossListing from '@/modules/promotion/components/EditReturnLoss/components/EditReturnLossListing'

function EditReturnLossPage() {
	return (
		<PageContainer>
			<EditReturnLossListing />
		</PageContainer>
	)
}

const GuardedEditReturnLossPage = withUserPermission(EditReturnLossPage, {
	permissionType: PermissionType.Write,
	permissionKey: [PermissionKeys.MANAGE_RETURN_LOSS],
})

export default GuardedEditReturnLossPage
